import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import Attachments from '../attachments/attachments';
import BubbleContent from '../content/bubble_content';
import ConversationItem from 'models/conversation_item';
import ItemContent from '../item_content';
import ItemMetadata from '../item_metadata';
import SafeHtml from 'components/common/safe_html';

export default function NoteItem({ className, isFirstInStack, isLastInStack, isStacked, item }) {
  return (
    <ItemContent
      isFirstInStack={isFirstInStack}
      isLastInStack={isLastInStack}
      isStacked={isStacked}
      item={item}
      showIcon={!isStacked}
    >
      <ItemMetadata item={item} showMetadata={!isStacked} text="added a note" />
      <NoteContent className={className} item={item} />
    </ItemContent>
  );
}

NoteItem.propTypes = {
  className: PropTypes.string,
  isFirstInStack: PropTypes.bool,
  isStacked: PropTypes.bool,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

export function NoteContent({ className, item }) {
  const { bodyHtml } = item.content;

  return (
    <BubbleContent className={classnames('noteContent', className)} item={item}>
      <SafeHtml dir="auto" html={bodyHtml} />
      <Attachments attachments={item.content.attachments || []} pathPrefix="note" />
    </BubbleContent>
  );
}

NoteContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/note/note_item.jsx